export default {
    _prefix: "formEditor.QuestionGroupList",
    labels: {
        questionGroupNumber: (data: {
            groupCount: number;
            totalGroupsCount: number;
        }) => "Group {{groupCount}} of {{totalGroupsCount}}",
        questionLimitReachedTooltip: (maxQuestionCount: {
            maxQuestionCount: number;
        }) =>
            "A form may not contain more than {{maxQuestionCount}} questions. Please delete one before adding another.",
    },
    addQuestion: {
        label: "Add Question",
        type: {
            multipleChoice: "Multiple Choice",
            yesOrNo: "Yes / No",
            range: "Range",
            readOnly: "Read Only",
            freeText: "Free Text",
            nps: "Net Promoter Score",
            multipleSelect: "Multiple Select",
        },
        answerOptions: {
            yes: "Yes",
            no: "No",
        },
    },
    addQuestionTemplate: {
        label: "Add Template Question",
        favorite: "Favorite",
    },
    error: {
        questionCount: "A question group must contain at least one question.",
    },
};
